import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import {createDropdownStore} from '../widgets/dropdown.js';

/**
 * Configures and starts Alpine.js
 */
export function initializeAlpine() {
    // Register dropdown store
    Alpine.store('dropdown', createDropdownStore());
    Alpine.plugin(intersect);
    Alpine.start();
}

/**
 * Processes teleported Alpine templates
 * @param {Function} initUI - UI initialization function to call on teleported content
 */
export function processTeleportedTemplates(initUI) {
    const templates = document.querySelectorAll('template[x-teleport]:not([data-ui-loaded])');

    templates.forEach((template) => {
        template.setAttribute('data-ui-loaded', '');
        const target = template._x_teleport;
        htmx.process(target);
        initUI(target);
    });
}

/**
 * Updates clan pending count in Alpine data
 * @param {number} count - New pending count
 */
export function updateClanPendingCount(count) {
    const clanContent = document.getElementById('clan-content');
    if (clanContent) {
        Alpine.$data(clanContent).pendingCount = count;
    }
}

// Export Alpine for global access
export default Alpine;
